import { BSC_CHAIN_ID } from '@/constants/bsc'

// Predict.fun API constants
export const PREDICT_FUN_API_URL = 'https://api.predict.fun/v1'
export const PREDICT_FUN_API_KEY = 'ce0247c7f6948b570439f9261d81102a6859'
export const PREDICT_FUN_WS_URL = 'wss://ws.predict.fun/ws'
export const PREDICT_FUN_CHAIN_ID = BSC_CHAIN_ID

// USDT on BSC (the SDK's collateral token)
export const BSC_USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955'

/**
 * Authenticated API call helper for Predict.fun REST API.
 * Uses JWT for user-specific endpoints (orders, positions).
 */
export async function predictFunFetch(path: string, options?: RequestInit & { jwt?: string }) {
	const { jwt, ...fetchOptions } = options ?? {}
	const headers: Record<string, string> = {
		accept: 'application/json',
		'content-type': 'application/json',
		'x-api-key': PREDICT_FUN_API_KEY,
	}
	if (jwt) {
		headers.authorization = `Bearer ${jwt}`
	}

	const res = await fetch(`${PREDICT_FUN_API_URL}${path}`, {
		...fetchOptions,
		headers: { ...headers, ...fetchOptions.headers },
	})

	if (!res.ok) {
		throw new Error(`Predict.fun API ${res.status}: ${await res.text()}`)
	}

	return res.json()
}
